import { stringify } from 'query-string';
import { fetchJSON } from '@catalogo/core-http';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = email => EMAIL_PATTERN.test(email);

export const getSimilarUrl = ({ breadcrumb = [] }) => {
  const first = breadcrumb?.[0] || {};
  return first.url;
};

const fmtNotifyMeUrl = ({ productId, sku, email, name, url }) => {
  const params = {
    IDPRODUCT: productId,
    SKU: sku,
    event_id: 1008,
    event_name: 'CR_AVISE_ME',
    mail: email,
    n: name,
    o: 11,
    opt: 'in',
    send_email: true,
  };

  return `${url}?${stringify(params)}`;
};

export const fetchNotifyMe = ({ productId, sku, email, name, url }) => {
  const notifyUrlWithParams = fmtNotifyMeUrl({ productId, sku, email, name, url });
  return fetchJSON(notifyUrlWithParams);
};
